import React from "react";
import { Box, Heading, Paragraph, ResponsiveContext } from "grommet";
export var NewsBanner = function NewsBanner(_ref) {
  var image = _ref.image,
    paragraph = _ref.paragraph,
    heading = _ref.heading,
    publication_date = _ref.publication_date;
  return /*#__PURE__*/ React.createElement(
    "div",
    null,
    /*#__PURE__*/ React.createElement(ResponsiveContext.Consumer, null, function (size) {
      return /*#__PURE__*/ React.createElement(
        Box,
        {
          margin: {
            bottom: "medium",
          },
          height: {
            max: "740px",
            min: "180px",
          },
          background: {
            image:
              "linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.8)), url(" + image + ")",
            size: "cover",
          },
        },
        /*#__PURE__*/ React.createElement(
          Box,
          {
            flex: {
              grow: 1,
            },
            width: {
              max: "1200px",
            },
            pad: {
              horizontal: "medium",
            },
            margin: {
              horizontal: "auto",
              vertical: "xlarge",
            },
            gap: "medium",
            justify: "end",
            fill: true,
          },
          /*#__PURE__*/ React.createElement(
            Box,
            {
              pad: {
                bottom: "large",
                top: "small",
              },
            },
            /*#__PURE__*/ React.createElement(
              Paragraph,
              {
                size: "0.75rem",
                color: "white",
              },
              publication_date
            )
          ),
          /*#__PURE__*/ React.createElement(
            Heading,
            {
              level: 3,
              color: "white",
              fill: true,
              style: {
                lineHeight: "1.5",
              },
            },
            heading
          ),
          /*#__PURE__*/ React.createElement(
            Paragraph,
            {
              size: "1rem",
              color: "white",
              fill: true,
            },
            paragraph
          )
        )
      );
    })
  );
};
